export default "/images/b63ff0fab003bd90b2fb37c915b52cc7.avif";